<script setup lang="ts">
import MarkdownView from "@/core/components/markdown/Markdown.vue";
import {computed} from "vue";

const props = defineProps<{
    description: string;
}>();

const columns = computed(() => props.description.split('---'));
</script>

<template>
  <div
    class="flex gap-4"
    :style="{width: columns.length * 440 + 'px', 'max-width': 'calc(100vw - 2rem)'}"
  >
    <div v-for="(column, index) in columns" :key="index" class="flex-1 min-w-0">
      <MarkdownView :content="column" class="text-sm" />
    </div>
  </div>
</template>

<style scoped>
:deep(h1) {
    @apply text-sm font-bold text-primary m-0 mb-1 p-0;
}

:deep(ul) {
    @apply my-0 pl-4;
}

:deep(li) {
    @apply m-0 py-[3px] leading-5;
}
</style>
